import { BaseEntity, Column, Entity, Index, JoinColumn, JoinTable, ManyToMany, ManyToOne, OneToMany, OneToOne, PrimaryColumn, PrimaryGeneratedColumn, RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn } from "typeorm";
import { Supplier } from "./supplier.entity";

// import { VendorsPriceList } from "../vendors-price-list/entities/vendor-price-list.entity";

@Entity('farms')
export class Farm {

    @PrimaryGeneratedColumn("increment", { name: 'farm_id' })
    farmId: number;

    @Column("char", {
        nullable: false,
        length: 50,
        name: "code"
    })
    @Index({ unique: true })
    farmCode: string;

    @Column("varchar", {
        nullable: true,
        length: 50,
        name: "name"
    })
    farmName: string;




    @Column("varchar", {
        nullable: true,
        length: 50,
        name: "address"
    })
    address: string;
    @Column("int", {
        nullable: false,
        name: "no_of_acres"
    })
    NumberOfAcres: number;
    @Column("int", {
        nullable: false,
        name: "no_of_ponds"
    })
    numberOfPonds: number;
    @Column("varchar", {
        nullable: false,
        length: 100,
        name: "trace_code"
    })
    traceCode: string;
    @Column("int", {
        nullable: false,
        name: "certification_id"
    })
    certificationId: number;

    @Column("varchar", {
        nullable: true,
        length: 100,
        name: "certification_code"
    })
    certificationCode: string;

    @Column("date", {
        nullable: false,
        name: "exp_date"
    })
    expiryDate: Date;

    @Column("varchar", {
        nullable: true,
        length: 20,
        name: "mobile_no"
    })
    mobileNumber: string;
    @Column("boolean", {
        nullable: false,
        default: true,
        name: "is_active"
    })
    isActive: boolean;
    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "created_user"
    })
    createdUser: string | null;


    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "updated_user"
    })
    updatedUser: string | null;


    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;

    @ManyToOne(type => Supplier, supplier => supplier.farmInfo, { nullable: false, })
    @JoinColumn({ name: "farmer_id" })
    supplierInfo: Supplier;


}
